import { Directive, ElementRef, HostListener, Injector } from '@angular/core';
import { NgControl, FormControlName } from '@angular/forms';


@Directive({
    selector: 'input[numOnly]',
    providers: [],
    standalone: false
})
export class NumberOnlyControlDirective {

  constructor(private el: ElementRef, private injector: Injector) { }

  @HostListener('input', ['$event'])
  onInputed() {
    const fcn = this.injector.get(NgControl, null) as FormControlName;
    const target = this.el.nativeElement as HTMLInputElement;
    let value = target.value;
    value = value.split('').filter(v => !isNaN(Number(v))).join('');
    value = value.split(/\s+/g).join('');
    target.value = value;
    fcn.control.setValue((value) ? Number(value) : null);
  }
}
